export const RESET = 'EXSBORDER_LIST_RESET'
export const SET_ITEMS = 'EXSBORDER_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBORDER_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBORDER_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBORDER_LIST_TOGGLE_LOADING'
